module.exports = __webpack_public_path__ + "b3aa33f009970dbf051bc90c84f21919.jpg";